<span class="company-badge" [style]="styles()" [matTooltip]="tooltip()">
  {{ label() }}
</span>
